export class GrowerOrderTransferVM {
  rowId: number;
  CropYear: number;
  CompanyCode: string;
  ItemId: number;
  ItemNumber: string;
  ItemDescription: string;
  Brand: string;
  MarketingBrand: string;
  PrimaryUom: string;
  Conv: number;
  FromShipToAccount: number;
  OriginalFromQty: number;
  FromPrimaryQty: number;
  FromModifyQty: number;
  FromQty: number;
  FromDeliveryDate: Date;
  FromCustomerPO: string;
  FromOrderId: number;
  FromOrderNo: string;
  FromOrderItemId: number;
  FromGLN: string;
  FromSellerId: number;
  ToOrderNo: string;
  ToOrderId: number;
  ToShipToAccount: number;
  ToPrimaryQty: number;
  ToSecondaryQty: number;
  ToQty: number;
  ToDeliveryDate: Date;
  ToCustomerPO: string;
  ToGLN: string;
  ToSellerId: number;
  FromChangeType: string;
  ToChangeType: string;
  FromGMK: number;
  ToGMK: number;
  LineErrors: any;
  EmailTo: string;
  seedNonReturnable: boolean;
  // TODO: Sumit - GMK
}
